import styled from 'styled-components';

export const TCDashboardTabsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: ${({ theme }) => theme.yoga.spacing.small}px;
  grid-row-gap: ${({ theme }) => theme.yoga.spacing.small}px;
  margin-top: ${({ theme }) => theme.yoga.spacing.large}px;

  > * {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  > :nth-child(1) {
    grid-area: 1 / 1 / 3 / 2;
  }

  > :nth-child(2) {
    grid-area: 1 / 2 / 3 / 3;
  }

  > :nth-child(3) {
    grid-area: 1 / 3 / 3 / 4;
  }

  > :nth-child(4) {
    grid-area: 1 / 4 / 3 / 5;
  }

  > :nth-child(5) {
    grid-area: 1 / 5 / 3 / 6;
  }

  > :nth-child(6) {
    grid-area: 1 / 6 / 2 / 7;
  }

  > :nth-child(7) {
    grid-area: 2 / 6 / 3 / 7;
  }
`;
